import { useMutation, useQuery } from '@tanstack/react-query';
import { IntegrationAPI, ISetting } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const integrationAPI = new IntegrationAPI(axios);

export const useIntegrationByIdnQuery = (integrationIdn: string) => {
    return useQuery({
        queryKey: ['integration/by-idn', integrationIdn],
        queryFn: async () => integrationAPI.getIntegrationByIdn(integrationIdn)
    });
};

export const useByIntegrationIdnConnectorsQuery = (integrationIdn: string) => {
    return useQuery({
        queryKey: ['integration/by-idn/connectors', integrationIdn],
        queryFn: async () =>
            integrationAPI.getByIntegrationIdnConnectors(integrationIdn)
    });
};

export const useChangeConnectorSettingsMutation = () => {
    return useMutation({
        mutationFn: async ({
            connectorId,
            data
        }: {
            connectorId: string;
            data: ISetting[];
        }) => integrationAPI.changeConnectorSettings(connectorId, data)
    });
};
